import { Button } from '@rocketmakers/armstrong';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { useRoutePaths } from '../../../shared/context/paths';
import { routePaths } from '../routes';
import { Header } from '../components/layout/header/header';
import './shell.scss';

export const Shell: React.FunctionComponent<unknown> = props => {
  const { push } = useRoutePaths();
  const handleClick = () => {
    push(routePaths.installationGuides.root);
  };

  const {
    location: { pathname },
  } = useHistory();

  const onInstallerGuideScreen = pathname === routePaths.installationGuides.root;

  return (
    <div className="shell">
      <Header />
      <main>{props.children}</main>
      <footer>
        {!onInstallerGuideScreen && (
          <Button
            onClick={handleClick}
            className="btn btn-outline btn-large btn-full"
            data-qa="installation-guide-button"
          >
            View latest installation guide
          </Button>
        )}
        <div data-qa="app-version" className="shell__footer">
          Version: <span className="shell__footer-version">{APP_CONFIG.version}</span>
        </div>
      </footer>
    </div>
  );
};
